import auth0 from 'auth0-js'
import { AUTH_CONFIG } from './auth0-variables'
import EventEmitter from 'eventemitter3'
import router from './../router'
import axios from 'axios'

const api = () => {
  return axios.create({
    baseURL: process.env.API_ENDPOINT
  })
}

export default class AuthService {
  authenticated = this.isAuthenticated()
  authNotifier = new EventEmitter()
  cust = this.cust()
  // loggedIn = this.loggedIn()
  // loggedIn2 = this.loggedIn3

  constructor () {
    this.login = this.login.bind(this)
    this.setSession = this.setSession.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
    // this.loggedIn = this.loggedIn.bind(this)
  }

  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid'
  })

  login () {
    this.auth0.authorize()
  }

  handleAuthentication () {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.loggedIn(authResult)
        // this.setSession(authResult)
        // router.replace('home')
      } else if (err) {
        router.replace('home')
        console.log(err)
        alert(`Error: ${err.error}. Check the console for further details.`)
      }
    })
  }
  loggedIn (authResult) {
    let custId = authResult.idTokenPayload.sub.slice(6)
    let custAdd = 'customer/log/' + custId
    api().get(custAdd)
      .then((response) => {
        this.setSession(authResult, response.data.customer)
      })
  }
  setSession (authResult, cust) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    )
    // let role = authResult.idTokenPayload['https://galeriehome.co.uk/roles']
    // let admin = role[0] === 'admin'
    // let custAcc = authResult.idTokenPayload['https://galeriehome.co.uk/acc']
    // let custId = authResult.idTokenPayload.sub.slice(6)
    localStorage.setItem('ci', cust.Auth0Id)
    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)
    localStorage.setItem('acc', cust.Acc)
    localStorage.setItem('name', cust.Name)
    localStorage.setItem('role', cust.Role)
    localStorage.setItem('type', cust.Type)
    this.authNotifier.emit('authChange', { authenticated: true, cust: cust })
    router.replace('home')
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('ci')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('acc')
    localStorage.removeItem('name')
    localStorage.removeItem('role')
    localStorage.removeItem('type')
    this.userProfile = null
    this.authNotifier.emit('authChange', false)
    // navigate to the home route
    router.replace('home')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    if (new Date().getTime() < expiresAt) {
      // this.loggedIn(localStorage.getItem('ci'))
    }
    return new Date().getTime() < expiresAt
  }
  cust () {
    let cust = []
    cust.Auth0Id = localStorage.getItem('ci')
    cust.Acc = localStorage.getItem('acc')
    cust.Name = localStorage.getItem('name')
    cust.Role = localStorage.getItem('role')
    return cust
  }
}
